<template>
    <div class="column is-12 mb-2">
        <div class="card">
            <div class="card-content">
                <b-button
                    rounded
                    size="is-small"
                    class="is-pulled-right is-size-7 ml-2"
                    @click.prevent="showModal()"
                >
                    View
                </b-button>

                <p class="title mb-1 is-6">
                    {{ appointment.Type }}
                    <b-tooltip label="Appointment has already happened">
                        <b-icon
                            v-if="isPast"
                            icon="check-circle"
                            size="is-small"
                            class="ml-h"
                        />
                    </b-tooltip>
                </p>

                <p
                    v-if="appointment.Start"
                    class="subtitle mt-1 is-7"
                >
                    <small class="is-size-7 has-text-grey">
                        {{ appointment.Start | formatDateTime }}
                    </small>
                </p>

                <p
                    v-if="appointment.PropertyAddress"
                    class="has-text-grey"
                >
                    {{ appointment.PropertyAddress }}
                </p>
            </div>
            <footer
                v-if="isFeedbackAllowed"
                class="card-footer"
            >
                <a
                    href="#"
                    class="card-footer-item"
                    @click.prevent="showModal()"
                >
                    <small>Provide feedback</small>
                </a>
            </footer>
        </div>
    </div>
</template>

<script>
import AppointmentModal from './AppointmentModal.vue';

export default {
    props: {
        appointment: {
            type: Object,
            required: true,
        },
    },

    computed: {
        isViewing: function () {
            const appointmentType = this.appointment.Type.toLowerCase();
            return appointmentType.includes('viewing');
        },
        isAppointmentOwner: function () {
            return (this.appointment.ContactFK === this.$meta.contactId);
        },
        isTenantOrLettingsApplicant: function () {
            return this.$meta.isTenantOrLettingsApplicant;
        },
        isPast: function () {
            return this.$dayjs(this.appointment.Start).isBefore(this.$dayjs());
        },
        isFeedbackAllowed: function () {
            return (this.isViewing && this.isAppointmentOwner && this.isTenantOrLettingsApplicant && this.isPast);
        },
    },

    methods: {
        showModal() {
            this.$buefy.modal.open({
                parent: this,
                component: AppointmentModal,
                hasModalCard: true,
                props: {
                    isFeedbackAllowed: this.isFeedbackAllowed,
                    appointment: this.appointment,
                },
            });
        },
    },
};
</script>
